import {
  type EuMaxTaxExposureDto,
  EuMaxTaxExposureDtoTreatmentEnum,
} from '@b-stock/listing-api-client'

// The VAT cents a confirm modal may fold into Estimated Total. Same clamps
// as `MaxVatExposureDisplay`: REVERSE_CHARGE is a real 0 (FR-021) and an
// unavailable estimate contributes nothing (FR-020), whatever the DTO carries.
const getMaxVatCents = (data: EuMaxTaxExposureDto | undefined): number => {
  if (
    !data ||
    data.estimateUnavailable ||
    data.treatment === EuMaxTaxExposureDtoTreatmentEnum.ReverseCharge
  ) {
    return 0
  }
  return data.maxVatAmount ?? 0
}

export default getMaxVatCents
